import React, { useRef, useState, useEffect } from "react";
import {
  serverTimestamp,
  setDoc,
  getDoc,
  doc,
} from "firebase/firestore";

import { db } from "../config/firebase";

const urlParams = new URLSearchParams(window.location.search);
const currentDomain = urlParams.get("parentUrl");

function Chatfooter(props) {
  const [localdata, setlocaldata] = useState("");
  const [formValue, setFormValue] = useState("");
  const scrollref = useRef(null);
  const abortControllerRef = useRef(null); // Track ongoing requests

  const currentTime = new Date();
  let hours = currentTime.getHours();
  const minutes = currentTime.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  const datehours = (hours) % 24;
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const month = String(currentTime.getMonth() + 1).padStart(2, "0");
  const day = String(currentTime.getDate()).padStart(2, "0");
  const year = currentTime.getFullYear();
  const currentTimeString = `${formattedHours}:${formattedMinutes} ${ampm}`;
  const seconds = currentTime.getSeconds();
const simIndexRef = useRef(0);
const simRunningRef = useRef(false);
  const date_string = `${month}/${day}/${year}, ${datehours}:${formattedMinutes}:${seconds}`;
  const { isLoading, setIsLoading, setShowChatHistory, setStartNewChat, startNewChat, resetFooter } = props;
// Add this conversation script at the top of your component file (outside the component)
 const products = [
  {"Website_Link":"","Image":"https://headsupfortails.com/cdn/shop/files/HUFTSiliconPetGroomingBrush.jpg?v=1757406719","MRP":"799","Name":"HUFT Silicon Pet Grooming Brush","Sell_Price":749},
   {"Website_Link":"","Image":"https://headsupfortails.com/cdn/shop/files/Hearty_Turkey_Fish_Chicken_Grain-Free_Oven-Baked_Adult_Dog_Food_-_All_Breeds_01.jpg?v=1757396377","MRP":"","Name":"Hearty Grain-Free Oven-Baked Adult Dog Food with Turkey, Fish & Chicken – Suitable for All Breeds – Preservative-Free, Complete & Balanced","Sell_Price":1999},
    {"Website_Link":"","Image":"https://headsupfortails.com/cdn/shop/files/HUFTSiliconPetGroomingBrush.jpg?v=1757406719","MRP":"799","Name":"HUFT Silicon Pet Grooming Brush","Sell_Price":749},
   {"Website_Link":"","Image":"https://headsupfortails.com/cdn/shop/files/Hearty_Turkey_Fish_Chicken_Grain-Free_Oven-Baked_Adult_Dog_Food_-_All_Breeds_01.jpg?v=1757396377","MRP":"","Name":"Hearty Grain-Free Oven-Baked Adult Dog Food with Turkey, Fish & Chicken – Suitable for All Breeds – Preservative-Free, Complete & Balanced","Sell_Price":1999},
    
 ]

const SIMULATION_SCRIPT = [
  { from: "user", text: "Hi, I just adopted a Golden Retriever puppy. What should I buy first?" },
  { from: "bot", text: "Congratulations 🐶! Here are essentials for a Golden Retriever puppy:" },
  {from :"product",AllProducts:products},
 
  { from: "user", text: "I only need dog food" },
  { from: "bot", text: "Large breeds benefit from early joint support.\nCustomers usually add Joint Treats — want to see a combo offer?" },
  { from: "user", text: "Where is my order?" },
  { from: "bot", text: "Order #HF48291 is out for delivery today before 7 PM.\n\nLive tracking link shared ✅" },
  { from: "bot", text: "Hey 👋 You checked orthopedic dog beds yesterday.\nGood news — they are 10% off today." },
  { from: "user", text: "My dog has skin allergy." },
  { from: "bot", text: "Connecting you with a HUFT nutrition expert now 🩺" },
];


  

  let photoURL = "testing";

  function getCurrentISTDate() {
    const date = new Date();
    const utcOffset = date.getTimezoneOffset();
    const istOffset = 330;
    const istDate = new Date(date.getTime() + (istOffset + utcOffset) * 60000);
    const year = istDate.getFullYear();
    const month = String(istDate.getMonth() + 1).padStart(2, '0');
    const day = String(istDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  // Cleanup function to abort ongoing requests
  const cleanup = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
  };

  // Reset footer when isLoading changes from parent (when chat resets)
  useEffect(() => {
    if (!isLoading) {
      // Cleanup any ongoing requests when parent says we're not loading
      cleanup();
      setFormValue("");
    }
  }, [isLoading]);

  // Reset footer when chat resets (triggered by parent)
  useEffect(() => {
    if (resetFooter) {
      cleanup();
      setFormValue("");
      setIsLoading(false);
    }
  }, [resetFooter, setIsLoading]);

  // Reset form state on component mount (after refresh)
  useEffect(() => {
    setFormValue("");
    setIsLoading(false);
  }, [setIsLoading]);

  useEffect(() => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    if (scrollref.current && !isMobile) {
      scrollref.current.focus();
    }
  }, []);



  useEffect(() => {
    if (startNewChat) {
      const data_var = currentDomain + "myData";
      localStorage.removeItem(data_var);
      // Reset footer state when starting new chat
      cleanup();
      setFormValue("");
      setIsLoading(false);
    }
  }, [startNewChat, setStartNewChat, setIsLoading]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      cleanup();
    };
  }, []);

// Add these refs inside your component (alongside existing refs)


// Replace your handlechange function entirely with this:
// const handlechange = async (e) => {
//   e.preventDefault();

//   const urlParams = new URLSearchParams(window.location.search);
//   const currentDomain = urlParams.get("parentUrl");
//   const shopId = currentDomain || "null";

//   function setCookie(name, value, days = 30) {
//     const expires = new Date();
//     expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
//     document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
//   }

//   function getCookie(name) {
//     const nameEQ = name + "=";
//     const ca = document.cookie.split(';');
//     for (let i = 0; i < ca.length; i++) {
//       let c = ca[i];
//       while (c.charAt(0) === ' ') c = c.substring(1, c.length);
//       if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
//     }
//     return null;
//   }

//   const uidvar = currentDomain + "uid";
//   const uid = getCookie(uidvar) || "";
//   const data_var = currentDomain + "myData";
//   const storedData = getCookie(data_var);

//   if (!formValue) return;

//   // If simulation already running, ignore extra submits
//   if (simRunningRef.current) return;

//   // Reset simulation index on first message
//   simIndexRef.current = 0;
//   simRunningRef.current = true;

//   cleanup();
//   setIsLoading(true);
//   setFormValue("Replying...");

//   // Resolve docid
//   let docid = "";
//   if (!storedData) {
//     const initialData = { key: uid + Date.now().toString() };
//     setCookie(data_var, JSON.stringify(initialData));
//     docid = initialData.key;
//   } else {
//     const parsedData = JSON.parse(storedData);
//     docid = parsedData.key;
//   }

//   const docRef = doc(db, "Messages", docid);

//   // Helper: get current time string
//   function getTimeStr() {
//     const now = new Date();
//     let h = now.getHours();
//     const m = String(now.getMinutes()).padStart(2, "0");
//     const ampm = h >= 12 ? "PM" : "AM";
//     h = h % 12 || 12;
//     return `${String(h).padStart(2, "0")}:${m} ${ampm}`;
//   }

//   function getDateStr() {
//     const now = new Date();
//     const mo = String(now.getMonth() + 1).padStart(2, "0");
//     const d = String(now.getDate()).padStart(2, "0");
//     const y = now.getFullYear();
//     const h = now.getHours() % 24;
//     const m = String(now.getMinutes()).padStart(2, "0");
//     const s = now.getSeconds();
//     return `${mo}/${d}/${y}, ${h}:${m}:${s}`;
//   }

//   // Initialize Firestore doc if it doesn't exist yet
//   const docSnap = await getDoc(docRef);
//   if (!docSnap.exists()) {
//     await setDoc(docRef, {
//       Chat_Status: "Open",
//       Fetch_Firestore: true,
//       Messages: [],
//       server: false,
//       user_id: uid,
//       shop_id: shopId,
//       User_Channel: "Web",
//       timestamp: Date.now(),
//       photoURL: "testing",
//       ticket_id: docid,
//       assigned_to: "bot@krunk.ai",
//       doc_id: docid,
//       created_at: serverTimestamp(),
//       last_updated: serverTimestamp(),
//     });
//   }

//   // Run the full simulation sequence
//   const delays = {
//     beforeUser: 2000,   // pause before each user message appears
//     afterUser: 500,     // pause after user message before bot starts typing
//     botTyping: 1800,    // bot "typing" duration
//     betweenBots: 3000,  // pause before consecutive bot messages
//   };

//   for (let i = 0; i < SIMULATION_SCRIPT.length; i++) {
//     const step = SIMULATION_SCRIPT[i];
//     const prevStep = i > 0 ? SIMULATION_SCRIPT[i - 1] : null;

//     if (step.from === "user") {
//       // Simulate typing in the input field character by character
//       await new Promise((r) => setTimeout(r, i === 0 ? 300 : delays.beforeUser));
      
//       let typed = "";
//       for (const char of step.text) {
//         typed += char;
//         setFormValue(typed);
//         await new Promise((r) => setTimeout(r, 30 + Math.random() * 20));
//       }

//       await new Promise((r) => setTimeout(r, 400));
//       setFormValue("Replying...");
//       setIsLoading(true);

//       // Write user message to Firestore
//       const freshSnap = await getDoc(docRef);
//       const existingMessages = freshSnap.exists() ? (freshSnap.data().Messages || []) : [];
//       existingMessages.push({
//         user: step.text,
//         user_timestamp: getDateStr(),
//         time: getTimeStr(),
//       });

//       await setDoc(docRef, {
//         Messages: existingMessages,
//         server: false,
//         user_id: docid,
//         shop_id: shopId,
//         User_Channel: "Web",
//         timestamp: Date.now(),
//         last_updated: serverTimestamp(),
//       }, { merge: true });

//       // Update widget UI with user message
//       props.messageupdate([{
//         server: false,
//         text: step.text,
//         photoURL: "icon.png",
//         uid: uid,
//         time: getTimeStr(),
//         timestamp: Date.now(),
//       }]);

//       await new Promise((r) => setTimeout(r, delays.afterUser));

//     }else if(step.from == "product") {
//       // Bot message
//       const waitBefore = prevStep?.from === "bot" ? delays.betweenBots : delays.botTyping;
//       // await new Promise((r) => setTimeout(r, waitBefore));

//       // Write bot/server message to Firestore
//       const freshSnap = await getDoc(docRef);
//       const existingMessages = freshSnap.exists() ? (freshSnap.data().Messages || []) : [];
//       existingMessages.push({
//         AllProducts: products,
//         Product:true,
//         server_timestamp: getDateStr(),
//         time: getTimeStr(),
//       });

//       await setDoc(docRef, {
//         Messages: existingMessages,
//         server: true,
//         user_id: docid,
//         shop_id: shopId,
//         User_Channel: "Web",
//         timestamp: Date.now(),
//         last_updated: serverTimestamp(),
//       }, { merge: true });

//       // Update widget UI with bot message
//       props.messageupdate([{
//         server: true,
//         text: step.text,
//         photoURL: "icon.png",
//         uid: "bot",
//         time: getTimeStr(),
//         timestamp: Date.now(),
//       }]);

//       // Reset input after first bot reply
//       if (prevStep?.from === "user") {
//         setIsLoading(false);
//         setFormValue("");
//       }
//     }
    
    
//     else {
//       // Bot message
//       const waitBefore = prevStep?.from === "bot" ? delays.betweenBots : delays.botTyping;
//       await new Promise((r) => setTimeout(r, waitBefore));

//       // Write bot/server message to Firestore
//       const freshSnap = await getDoc(docRef);
//       const existingMessages = freshSnap.exists() ? (freshSnap.data().Messages || []) : [];
//       existingMessages.push({
//         server: step.text,
//         server_timestamp: getDateStr(),
//         time: getTimeStr(),
//       });

//       await setDoc(docRef, {
//         Messages: existingMessages,
//         server: true,
//         user_id: docid,
//         shop_id: shopId,
//         User_Channel: "Web",
//         timestamp: Date.now(),
//         last_updated: serverTimestamp(),
//       }, { merge: true });

//       // Update widget UI with bot message
//       props.messageupdate([{
//         server: true,
//         text: step.text,
//         photoURL: "icon.png",
//         uid: "bot",
//         time: getTimeStr(),
//         timestamp: Date.now(),
//       }]);

//       // Reset input after first bot reply
//       if (prevStep?.from === "user") {
//         setIsLoading(false);
//         setFormValue("");
//       }
//     }
//   }

//   // Simulation complete
//   setIsLoading(false);
//   setFormValue("");
//   simRunningRef.current = false;
// };


  const handlechange = async (e) => {
    const urlParams = new URLSearchParams(window.location.search);
    const currentDomain = urlParams.get("parentUrl");
    const channel = urlParams.get("channel") || "Web";
    const shopId = currentDomain || "null";

    // Helper function to set cookies with 30-day expiration
    function setCookie(name, value, days = 30) {
     localStorage.setItem(name, value);
    }

    // Helper function to get cookies
    function getCookie(name) {
    return localStorage.getItem(name);
    }

    const uidvar = currentDomain + "uid";
    let uid = getCookie(uidvar) || "";

    e.preventDefault();
    var docid = "";
    const data_var = currentDomain + "myData";
    const storedData = getCookie(data_var);

    if (!formValue) return;

    // Store the current form value before setting loading state
    const currentMessage = formValue;
    
    // Cleanup any existing request before starting new one
    cleanup();
    
    // Create new abort controller for this request
    abortControllerRef.current = new AbortController();
    const currentAbortController = abortControllerRef.current;
    
    setIsLoading(true);
    setFormValue("Replying...");

    try {
      if (!storedData) {
        const initialData = { key: uid + Date.now().toString() };
        setCookie(data_var, JSON.stringify(initialData));
        docid = initialData.key;
      } else {
        const parsedData = JSON.parse(storedData);
        docid = parsedData.key;
      }

      const newarray = [
        {
          server: false,
          text: currentMessage,
          photoURL: "icon.png",
          uid: uid,
          time: currentTimeString,
          timestamp: Date.now(),
        },
      ];
      props.messageupdate(newarray);

      const docRef = doc(db, "Messages", docid);
      const docSnap = await getDoc(docRef);
      let assigned_to = "bot@krunk.ai";

      if (docSnap.exists()) {
        var message = docSnap.data().Messages;
        assigned_to = docSnap.data().assigned_to;
        var lastmessage2 = message[message.length - 1];
        if (lastmessage2["server"] !== undefined) {
          message.push({ user: currentMessage, user_timestamp: date_string, time: currentTimeString });
          await setDoc(docRef, {
            Messages: message,
            server: false,
            user_id: docid,
            shop_id: shopId,
            User_Channel: "Web",
            timestamp: Date.now(),
            last_updated: serverTimestamp(),
          }, { merge: true });
        } else {
          message.push({ user: currentMessage, user_timestamp: date_string, time: currentTimeString });
          await setDoc(docRef, {
            Messages: message,
            server: false,
            user_id: docid,
            shop_id: shopId,
            User_Channel: "Web",
            timestamp: Date.now(),
            last_updated: serverTimestamp(),
          }, { merge: true });
        }
      } else {
        await setDoc(docRef, {
          Chat_Status: "Open",
          Fetch_Firestore: true,
          Messages: [ { user: currentMessage, user_timestamp: date_string, time: currentTimeString }],
          server: false,
          user_id: uid,
          shop_id: shopId,
          User_Channel: "Web",
          timestamp: Date.now(),
          photoURL,
          ticket_id: docid,
          assigned_to: "bot@krunk.ai",
          doc_id: docid,
          User_Timestamp: getCurrentISTDate(),
          created_at: serverTimestamp(),
          last_updated: serverTimestamp(),
        }, { merge: true });
      }

      var url = "";

      if (shopId == "null") {
        url = 'http://127.0.0.1:8080/server?docid=' + docid + "&shop_id=" + "JustWravels" + "&user_message=" + currentMessage;
        
        // url = 'http://127.0.0.1:8080/server?docid=' + docid + "&shop_id=" + "smilenbeauty" + "&user_message=" + currentMessage + "&source=Whatsapp";
        
        // url = 'http://127.0.0.1:8080/server?docid=' + docid + "&shop_id=" + "yaan-man.myshopify.com" + "&user_message=" + currentMessage;
      
      }
      else if (shopId == "Krunk.ai") {
        url = "https://krunk-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=" + docid + "&shop_id=" + "Krunk.ai";
      }
      else if (shopId == "HomesterOnboardingProperties") {
        url = 'https://homesteronboarding.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid + "&shop_id=" + "Krunk.ai";
      }
      else if (shopId == "JustWravels") {
      
        url = 'http://127.0.0.1:8080/server?docid=' + docid + "&shop_id=" + "JustWravels" + "&user_message=" + currentMessage;
        
       url = 'https://modular-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid + "&shop_id=" + "JustWravels" + "&user_message=" + currentMessage;
        //  url = 'http://127.0.0.1:8080/server?docid=' + docid + "&shop_id=" + "JustWravels" + "&user_message=" + currentMessage;
        
      }
      else if (shopId == "DivineHindu") {
        url = 'https://divine-hindu-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid + "&shop_id=" + "JustWravels";
      }
   
      else if (shopId == "YaanMan") {
        url = 'https://yaan-man.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid + "&shop_id=" + "YaanMan";
      }
      else if (shopId === "indidiva.com") {
        url = 'https://modular-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid + "&shop_id=" + "5a76ef-91.myshopify.com" + "&user_message=" + currentMessage;
      }
      else {
        //  url = 'https://modular-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid + "&shop_id=" + shopId+ "&user_message=" + currentMessage;
     url = 'http://127.0.0.1:8080/whatsapp?docid=' + docid + "&shop_id=" + "getmycouch.myshopify.com" + "&user_message=" + currentMessage;
      // url="https://smilenbeauty.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/chat?session_id="+docid+ "&message="+currentMessage;
      // url="http://127.0.0.1:8080/chat?session_id="+docid+ "&message="+currentMessage;
           
        // url = 'http://127.0.0.1:8080/server?docid=' + docid + "&shop_id=" + "JustWravels" + "&user_message=" + currentMessage;
            
    }

      const parenturl = urlParams.get('parentUrl')?.trim().toLowerCase();

      if (assigned_to == "bot@krunk.ai") {
        // Check if request was aborted before making the call
        if (currentAbortController.signal.aborted) {
          return;
        }

        await fetch(url, { 
          method: 'GET',
          signal: currentAbortController.signal
        })
        .then((hello) => {
          console.log("URL is fetched");
        })
        .catch((err) => {
          if (err.name !== 'AbortError') {
            console.log("No check", err);
          }
        });
      }
    } catch (error) {
      console.error("Error in handlechange:", error);
    } finally {
      // Only update state if this request wasn't aborted
      if (currentAbortController && !currentAbortController.signal.aborted) {
        setIsLoading(false);
        setFormValue("");
        // Clear the ref since this request completed
        if (abortControllerRef.current === currentAbortController) {
          abortControllerRef.current = null;
        }
      }
    }

    e.preventDefault();
  };




  return (
    <div className=" krunk-text-textcolor  krunk-mt-0 krunk-px-2 krunk-pt-1 krunk-rounded-b-xl">
      <div className="krunk-flex krunk-items-center krunk-mt-0 krunk-justify-between krunk-gap-2 krunk-border-2 krunk-border-buttonbackground krunk-rounded-lg krunk-p-1 ">
        <form
          className="krunk-flex krunk-items-center krunk-justify-between krunk-px-1 krunk-rounded-lg krunk-w-full krunk-bg-white"
          onSubmit={handlechange}
        >
          <input
            type="text"
            className="krunk-outline-none krunk-bg-transparent krunk-text-sm krunk-w-full krunk-h-8 krunk-text-black krunk-placeholder:text-sm krunk-px-3 krunk-disabled:pointer-events-none krunk-disabled:text-gray-400"
            placeholder="Ask me anything"
            onChange={(e) => setFormValue(e.target.value)}
            value={formValue}
            disabled={isLoading}
            ref={scrollref}
          />

          <button
            type="submit"
            className="krunk-w-[60px] krunk-flex krunk-items-center krunk-justify-center krunk-bg-gray-200 krunk-rounded-xl krunk-h-8 krunk-disabled:opacity-65 krunk-mr-1"
            disabled={isLoading}
          >
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              className="krunk-w-4 krunk-h-4"
            >
              <path 
                d="M12 4L12 20M12 4L18 10M12 4L6 10" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </form>
      </div>
      
      <div className="krunk-flex krunk-items-center krunk-justify-center krunk-gap-1 krunk-text-xs krunk-pt-1 krunk-pb-0">
        <h1>
          <span className="krunk-text-chatbackground">Powered by</span>{" "}
          <span className="krunk-text-chatbackground ">Krunk.ai</span>{" "}
        </h1>
        <img
          src="https://firebasestorage.googleapis.com/v0/b/open-source-28ce5.appspot.com/o/web_icons%2FLogo.svg?alt=media&token=5e4d9440-9ded-426e-be00-e82624f1b6f2"
          alt=""
          className="krunk-w-4"
        />
      </div>
    </div>
  );
}

export default Chatfooter;